export default __webpack_public_path__ + "static/media/img4.c275ee72.png";